/* eslint-disable max-len */
export const PERMISSIONS = {
    PhysicalConfirmation: {
        Access: 'CONFERENCIA_FISICA',
        Config: "LOGISTICS_CONFIG_CONFERENCIA_FISICA",
        Reopen: 'CONFERENCIA_FISICA_REABRIR',
    },
    Volume: {
        Access: 'VOLUME'
    },
    Inventory: {
        Access: 'INVENTARIO',
        ReenvioSIM: 'INVENTARIO_SEND_SIM',
        Queue: {
            Access: 'INVENTARIO_FILA'
        },
        Rotative: {
            Access: 'INVENTARIO_ROTATIVO',
            Operational: 'INVENTARIO_ROTATIVO_OPERACIONAL',
            Monitoring: 'INVENTARIO_ROTATIVO_MONITORAMENTO',
            LoadInventory: 'INVENTARIO_ROTATIVO_CARREGAR',
            Audit: 'INVENTARIO_ROTATIVO_AUDITORIA',
            ConnectLotUser: 'INVENTARIO_ROTATIVO_ASSOCIAR_USUARIO_LOTE',
            DiconnectLotUser: 'INVENTARIO_ROTATIVO_DESASSOCIAR_USUARIO_LOTE',
            Supervisor: 'INVENTARIO_ROTATIVO_SUPERVISAO',
        },
        General: {
            Access: 'INVENTARIO_GERAL',
            Operational: 'INVENTARIO_GERAL_OPERACIONAL',
            Monitoring: 'INVENTARIO_GERAL_MONITORAMENTO',
            Audit: 'INVENTARIO_GERAL_AUDITORIA',
            LoadInventory: 'INVENTARIO_GERAL_CARREGAR',
            ConnectLotUser: 'INVENTARIO_GERAL_ASSOCIAR_USUARIO_LOTE',
            DiconnectLotUser: 'INVENTARIO_GERAL_DESASSOCIAR_USUARIO_LOTE',
            Supervisor: 'INVENTARIO_GERAL_SUPERVISAO'
        },
        OverLine: {
            Access: 'INVENTARIO_SOBRE_LINHA'
        }
    },
    LoadUnload: {
        Access: 'CARGA_DESCARGA',
        Config: 'LOGISTICS_CONFIG_CARGA_DESCARGA'
    },
    Location: {
        Access: 'TROCA_LOCACAO',
        BlockLocation: 'TROCA_LOCACAO_BLOQUEAR',
        UnblockLocation: 'TROCA_LOCACAO_DESBLOQUEAR',
        CancelarTrocaLocacao: 'TROCA_LOCACAO_CANCELAR_TROCA'
    },
    Expedition: {
        Access: 'EXPEDICAO',
        PackList: {
            Access: 'PACKLIST',
            Manage: "PACKLIST_MANAGE",
            Finance: 'PACKLIST_FINANCE',
            Patrimonial: 'PACKLIST_PATRIMONIAL'
        },
        Picking: {
            Access: 'EXPEDICAO_PICKING',
            Filters: 'EXPEDICAO_PICKING_FILTROS',
            Voice: 'EXPEDICAO_PICKING_VOICE',
            ManageOrder: 'EXPEDICAO_PICKING_MANAGE_ORDER',
            Repicking: 'EXPEDICAO_REPICKING'
        },
    },
    Config: {
        Access: 'LOGISTICS_CONFIG',
        Global: {
            Access: 'LOGISTICS_CONFIG_GLOBAL',
            Plant: 'LOGISTICS_CONFIG_GLOBAL_PLANTA',
            Resource: 'LOGISTICS_CONFIG_GLOBAL_RECURSO',
            Printer: 'LOGISTICS_CONFIG_GLOBAL_IMPRESSORA',
            Justification: 'LOGISTICS_CONFIG_GLOBAL_JUSTIFICATION',
        },
        PhysicalConfirmation: {
            Access: 'LOGISTICS_CONFIG_CONFERENCIA_FISICA'
        },
        LoadUnload: {
            Access: 'LOGISTICS_CONFIG_CARGA_DESCARGA'
        },
        Expedition: {
            Access: 'LOGISTICS_CONFIG_EXPEDICAO',
            Picking: 'LOGISTICS_CONFIG_EXPEDICAO_PICKING',
        },
        Inventory: {
            Access: 'LOGISTICS_CONFIG_INVENTARIO'
        },
        ChangeLocation: {
            Access: 'LOGISTICS_CONFIG_TROCA_LOCACAO'
        },
        Equipment: {
            Access: 'LOGISTICS_CONFIG_EQUIPAMENTO'
        }
    },
    DigitalTracking: {
        Access: 'DIGITAL_TRACKING',
        Monitor: 'DIGITAL_TRACKING_MONITORING',
        WaitingTime: 'DIGITAL_TRACKING_WAITING_TIME',
        AlertShipment: 'SHIPMENT_TRACKING_ALERT'
    },
    Lowering: {
        Access: 'LOWERING',
        Repicking: 'LOWERING_REPICKING',
        ManageLowering: 'LOWERING_MANAGE_PICKING',
    },
    PABReplanning: {
        Access: 'PAB_REPLANNING',
        Repicking: 'REPLANNING_PAB_REPICKING',
        ManagePabReplanning: 'REPLANNING_PAB_MANAGE_PICKING',
    },
    LinePicking: {
        Access: 'LINE_PICKING',
        ManualCallPdu: 'PDU_LOCATION',
        ManualCallMapping: 'PDU_MAPPING',
        SmallParts: {
            Cart: 'LINE_PICKING_CART_ACCESS',
            Route: 'LINE_PICKING_ROUTE_ACCESS',
            Access: 'LINE_PICKING_ACCESS',
            Filters: 'LINE_PICKING_FILTER',
            OnDemand: 'LINE_PICKING_ONDEMAND',
            ManageLinePicking: 'LINE_PICKING_MANAGE_PICKING',
            Repicking: 'LINE_REPICKING'
        },
        WriteOff: {
            Access: 'WRITE_OFF',
            Filters: 'WRITE_OFF_FILTER',
            ManageWriteOff: 'MANAGE_WRITE_OFF',
            Route: 'WRITE_OFF_ROUTE_ACCESS',
        },
        Mapping: {
            Access: 'LINE_PICKING_MAPPING',
            Registrations: 'LINE_PICKING_MAPPING_REGISTRATIONS',
            QuantityAligment: 'LINE_PICKING_MAPPING_QUANTITY_ALIGNMENT'
        }
    },
    Delivery: {
        Access: 'DELIVERY',
        Filters: 'DELIVERY_FILTER',
        OnDemand: 'DELIVERY_ONDEMAND',
        ManageLineDelivery: 'DELIVERY_MANAGE_PICKING'
    },
    TRUCK_KANBAN: {
        Access: 'TRUCK_KANBAN',
        Config: 'TRUCK_KANBAN'
    },
    Stock: {
        Access: 'ESTOQUE_REALIZAR_BAIXA',
        Quality: 'ESTOQUE_REALIZAR_BAIXA_QUALIDADE'

    },
    UploadDifusion: {
        Access: 'DIFUSAO'
    },
    Warehouse_Container: {
        Access: 'WAREHOUSE_CONTAINER',
        ChangeStatus: {
            Transport: "WAREHOUSE_CONTAINER_CHANGE_STATUS_TRANSPORT",
            InPort: "WAREHOUSE_CONTAINER_CHANGE_STATUS_IN_PORT",
            Released: "WAREHOUSE_CONTAINER_CHANGE_STATUS_RELEASED",
            InPlant: "WAREHOUSE_CONTAINER_CHANGE_STATUS_IN_PLANT",
            InYard: "WAREHOUSE_CONTAINER_CHANGE_STATUS_IN_YARD",
            DockTransit: "WAREHOUSE_CONTAINER_CHANGE_STATUS_DOCK_TRANSIT",
            Unloaded: "WAREHOUSE_CONTAINER_CHANGE_STATUS_UNLOADED",
            ReturnToYard: "WAREHOUSE_CONTAINER_CHANGE_STATUS_RETURN_TO_YARD",
            ExitYard: "WAREHOUSE_CONTAINER_CHANGE_STATUS_EXIT_YARD",
            Exit: "WAREHOUSE_CONTAINER_CHANGE_STATUS_EXIT",
            ReturnToPort: "WAREHOUSE_CONTAINER_CHANGE_STATUS_RETURN_TO_PORT"
        },
        Storage: {
            Access: "WAREHOUSE_CONTAINER_STORAGE",
            Upload: "WAREHOUSE_CONTAINER_STORAGE_UPLOAD",
            Store: "WAREHOUSE_CONTAINER_STORAGE_STORE",
            Register: "WAREHOUSE_CONTAINER_STORAGE_REGISTER",
            RegisterSearch: "WAREHOUSE_CONTAINER_STORAGE_REGISTER_SRC",
            Ovate: "WAREHOUSE_CONTAINER_STORAGE_OVATE",
            Transfer: "WAREHOUSE_CONTAINER_STORAGE_TRANSF",
            UpdateStatus: "WAREHOUSE_CONTAINER_STORAGE_UP_STATUS",
            Dates: "WAREHOUSE_CONTAINER_STORAGE_DATES",
        },
        Spawning: {
            Access: "WAREHOUSE_CONTAINER_SPAWING",
            Total: "WAREHOUSE_CONTAINER_SPAWING_TOTAL",
            List: "WAREHOUSE_CONTAINER_SPAWING_LIST",
            ListSearch: "WAREHOUSE_CONTAINER_CONFIG_PATIO_SRC",
        },
        Config: {
            Access: "WAREHOUSE_CONTAINER_CONFIG",
            Patio: "WAREHOUSE_CONTAINER_CONFIG_PATIO",
            PatioSearch: "WAREHOUSE_CONTAINER_CONFIG_PATIO_SRC",
            UnloadLocation: "WAREHOUSE_CONTAINER_CONFIG_UNLOAD_LOCATION",
            UnloadLocationSearch: "WAREHOUSE_CONTAINER_CONFIG_UNLOAD_LOCATION_SRC",
            ContainerSize: "WAREHOUSE_CONTAINER_CONFIG_CONTAINER_SIZE",
            ContainerSizeSearch: "WAREHOUSE_CONTAINER_CONFIG_CONTAINER_SIZE_SRC",
            ExecutionCalculation: "WAREHOUSE_CONTAINER_CONFIG_EXECUTION_CALCULATION",
            ExecutionCalculationSearch: "WAREHOUSE_CONTAINER_CONFIG_EXEC_CALC_SRC",
            IssuerRegistration: "WAREHOUSE_CONTAINER_CONFIG_ISSUER_REGISTRATION",
            IssuerRegistrationSearch: "WAREHOUSE_CONTAINER_CONFIG_ISSUER_REGISTRATION_SRC",
            PlantConfig: "WAREHOUSE_CONTAINER_CONFIG_PLANT_CONFIG",
            PlantConfigSearch: "WAREHOUSE_CONTAINER_CONFIG_PLANT_CONFIG_SRC",
            BussinesHourConfig: "WAREHOUSE_CONTAINER_CONFIG_BUSSINESS_HOUR_CONFIG",
            BussinesHourConfigSearch: "WAREHOUSE_CONTAINER_CONFIG_BUS_HOUR_CONFIG_SRC",
            MaritimeCompany: "WAREHOUSE_CONTAINER_CONFIG_MARITIME_COMPANY",
            MaritimeCompanySearch: "WAREHOUSE_CONTAINER_CONFIG_MARITIME_COMPANY_SRC",
            Harbor: "WAREHOUSE_CONTAINER_CONFIG_HARBOR",
            HarborSearch: "WAREHOUSE_CONTAINER_CONFIG_HARBOR_SRC",
            Freetime: "WAREHOUSE_CONTAINER_CONFIG_FREETIME",
            FreetimeSearch: "WAREHOUSE_CONTAINER_CONFIG_FREETIME_SRC",
            MDR: "WAREHOUSE_CONTAINER_CONFIG_MDR",
            MDRSearch: "WAREHOUSE_CONTAINER_CONFIG_MDR_SRC"
        },
        Demurrage: {
            Access: "WAREHOUSE_CONTAINER_DEMURRAGE",
            Monitor: "WAREHOUSE_CONTAINER_DEMURRAGE_MONITOR",
            Alert: "WAREHOUSE_CONTAINER_DEMURRAGE_ALERT",
        },
        Search: {
            Access: "WAREHOUSE_CONTAINER_SEARCH",
            Status: "WAREHOUSE_CONTAINER_SEARCH_STATUS",
            Explosion: "WAREHOUSE_CONTAINER_SEARCH_EXPLOSION",
            History: "WAREHOUSE_CONTAINER_SEARCH_HISTORY",
            Partnumber: "WAREHOUSE_CONTAINER_SEARCH_PARTNUMBER",
        },
        Coverage: {
            Access: "WAREHOUSE_CONTAINER_COVERAGE",
            Calculation: "WAREHOUSE_CONTAINER_COVERAGE_CALCULATION",
            CriticalRegister: "WAREHOUSE_CONTAINER_COVERAGE_CRITICAL_REGISTER",
            PnParameter: "WAREHOUSE_CONTAINER_COVERAGE_PN_PARAMETER",
        }
    }

};

export const ENUMS = {
    eReceiptStatus: {
        Wait: {
            value: 1,
            text: 'physical-confirmation.receipt-status.wait'
        },
        Anomaly: {
            value: 2,
            text: 'physical-confirmation.receipt-status.anomaly'
        },
        Conference: {
            value: 3,
            text: 'physical-confirmation.receipt-status.conference'
        },
        Closed: {
            value: 4,
            text: 'physical-confirmation.receipt-status.closed'
        }
    },
    ePackListStatus: {
        Collected: {
            value: 1,
            text: 'expedition:picking.pack-list-status.collected'
        },
        PendingFinance: {
            value: 2,
            text: 'expedition:picking.pack-list-status.pending-finance'
        },
        PropertyPending: {
            value: 3,
            text: 'expedition:picking.pack-list-status.property-pending'
        },
        PackListAuthorized: {
            value: 4,
            text: 'expedition:picking.pack-list-status.pack-list-authorized'
        },
        PackListInvoiceOk: {
            value: 5,
            text: 'expedition:picking.pack-list-status.pack-list-invoice-ok'
        },
        InvoiceOk: {
            value: 6,
            text: 'expedition:picking.pack-list-status.invoice-ok'
        },
        ReprovedFinance: {
            value: 7,
            text: 'expedition:picking.pack-list-status.reproved-finance'
        },
        ReprovedPatrimonial: {
            value: 8,
            text: 'expedition:picking.pack-list-status.reproved-patrimonial'
        }
    },
    eOrderStatus: {
        Waiting: {
            value: 1,
            text: 'picking.order-status.waiting'
        },
        InProgress: {
            value: 2,
            text: 'picking.order-status.in-progress'
        },
        Finished: {
            value: 3,
            text: 'picking.order-status.finished'
        },
        Canceled: {
            value: 4,
            text: 'picking.order-status.canceled'
        },
        WaitingFinish: {
            value: 5,
            text: 'picking.order-status.waiting-finish'
        },
        WaitingRouteComposition: {
            value: 6,
            text: 'picking.order-status.waiting-route-composition'
        },
        WaitingRouteInformation: {
            value: 7,
            text: 'picking.order-status.waiting-route-information'
        },
        NotFound: {
            value: 8,
            text: 'picking.order-status.not-found'
        },
        NotFoundFinished: {
            value: 9,
            text: 'picking.order-status.not-found-finish'
        },
        OnHold: {
            value: 10,
            text: 'picking.order-status.on-hold'
        },
        ManuallyFinished: {
            value: 11,
            text: 'picking.order-status.manuallyfinished'
        }
    },
    eOrderPabStatus: {
        Waiting: {
            value: 1,
            text: "ESPERA"
        },
        Finished: {
            value: 3,
            text: "FECHADO"
        },
        Canceled: {
            value: 4,
            text: "CANCELADO"
        },
    },
    eOrderTypeRouteKanbanStatus: {
        Blue: {
            value: 1,
            text: 'blue'
        },
        Yellow: {
            value: 2,
            text: 'yellow'
        },
        Red: {
            value: 3,
            text: 'red'
        }
    },
    eMvmStatus: {
        Awaiting: {
            value: 1,
            text: 'physical-confirmation:awaiting'
        },
        InProgress: {
            value: 2,
            text: 'physical-confirmation:in-progress'
        },
        Finished: {
            value: 3,
            text: 'physical-confirmation:finished'
        }
    },
    eMviStatus: {
        Open: {
            value: 1,
            text: 'truck-kanban:open'
        },
        Finished: {
            value: 2,
            text: 'truck-kanban:finished'
        }
    },
    eOrderType: {
        Picking: {
            value: 1,
            text: 'line-picking:order-type.picking'
        },
        LinePicking: {
            value: 2,
            text: 'line-picking:order-type.linePicking'
        },
        Lowering: {
            value: 3,
            text: 'menu:lowering'
        },
        Delivery: {
            value: 4,
            text: 'delivery:title'
        },
        LoweringDelivery: {
            value: 5,
            text: 'delivery:title'
        },
        PabReplanning: {
            value: 6,
            text: 'menu:pabReplanning'
        },

    },
    eOrderLevel: {
        Low: {
            value: 1
        },
        Normal: {
            value: 2
        },
        High: {
            value: 3
        },
        Critical: {
            value: 4
        }
    },
    eOrderItemStatus: {
        Waiting: {
            value: 1,
            text: 'picking.order-item-status.waiting'
        },
        InProgress: {
            value: 2,
            text: 'picking.order-item-status.in-progress'
        },
        Repicking: {
            value: 3,
            text: 'picking.order-item-status.repicking'
        },
        Finished: {
            value: 4,
            text: 'picking.order-item-status.finished'
        },
        Canceled: {
            value: 5,
            text: 'picking.order-item-status.canceled'
        },
        WaitingRepicking: {
            value: 6,
            text: 'picking.order-item-status.waiting-repicking'
        },
        WaitingFinish: {
            value: 7,
            text: 'picking.order-item-status.waiting-finish'
        },
        NotFound: {
            value: 8,
            text: 'line-picking.linepicking.notfound'
        }
    },
    eOrderGroupType: {
        LinePicking: {
            value: 1,
        },
        Delivery: {
            value: 2,
        }
    },
    eOrderGroupStatus: {
        Waiting: {
            value: 1,
            text: 'picking.order-item-status.waiting'
        },
        InProgress: {
            value: 2,
            text: 'picking.order-item-status.in-progress'
        },
        Finished: {
            value: 3,
            text: 'picking.order-item-status.finished'
        },
        Canceled: {
            value: 4,
            text: 'picking.order-item-status.canceled'
        },
        WaitingFinalQrCode: {
            value: 5,
            text: 'picking.order-group-status.waiting-final-qrcode'
        }
    },
    eChatOriginMessage: {
        Server: {
            value: 1,
            text: 'Server'
        },
        User: {
            value: 2,
            text: 'User'
        }
    },
    eQrCodeType: {
        Dolly: {
            value: 1,
            text: 'Dolly'
        },
        Dock: {
            value: 2,
            text: 'Doca'
        },
        Frame: {
            value: 3,
            text: 'Frame'
        }
    },
    ePagination: {
        PageSize: {
            value: 10
        }
    },
    eInventoryType: {
        General: {
            value: 1,
            text: 'inventory.general'
        },
        Eventual: {
            value: 1,
            text: 'inventory.eventual'
        },
    },
    eInventoryOriginCount: {
        Drone: {
            value: 1,
            text: 'drone'
        },
        Mobile: {
            value: 2,
            text: 'mobile'
        },
        Undefined: {
            value: 0,
            text: 'undefined'
        }
    },
    eInventoryStatus: {
        Waiting: {
            value: 1,
            text: 'general.status-inventory.waiting'
        },
        Loading: {
            value: 2,
            text: 'general.status-inventory.loading'
        },
        Loaded: {
            value: 3,
            text: 'general.status-inventory.loaded'
        },
        InProgress: {
            value: 4,
            text: 'general.status-inventory.in-progress'
        },
        Finished: {
            value: 5,
            text: 'general.status-inventory.finished'
        },
        Canceled: {
            value: 6,
            text: 'general.status-inventory.canceled'
        }
    },
    eInventoryLotStatus: {
        Waiting: {
            value: 1,
            text: 'general.status-inventory-lot.waiting',
            color: '#CCCCCC'
        },
        Loading: {
            value: 2,
            text: 'general.status-inventory-lot.loading',
            color: '#FFBB28'
        },
        Loaded: {
            value: 3,
            text: 'general.status-inventory-lot.loaded',
            color: '#FF8042'
        },
        InProgress: {
            value: 4,
            text: 'general.status-inventory-lot.in-progress',
            color: '#597dda'
        },
        Finished: {
            value: 5,
            text: 'general.status-inventory-lot.finished',
            color: 'rgb(76, 175, 80)'
        },
        Canceled: {
            value: 6,
            text: 'general.status-inventory-lot.canceled',
            color: '#F45665'
        }
    },
    eInventoryLotItemStatus: {
        Waiting: {
            value: 1,
            text: 'general.status-inventory-lot-item.waiting'
        },
        InProgress: {
            value: 2,
            text: 'general.status-inventory-lot-item.in-progress'
        },
        Finished: {
            value: 3,
            text: 'general.status-inventory-lot-item.finished'
        },
        Canceled: {
            value: 4,
            text: 'general.status-inventory-lot-item.canceled'
        },
        Divergent: {
            value: 5,
            text: 'general.status-inventory-lot-item.divergent'
        }
    },
    ePrinterConnectionType: {
        Wifi: {
            value: 1,
            text: 'Wifi'
        },
        Bluetooth: {
            value: 2,
            text: 'Bluetooth'
        }
    },
    eTypeConfirmation: {
        Confirmation: {
            value: 1,
            text: 'Confirmation'
        },
        DeemUp: {
            value: 2,
            text: 'DeemUp'
        },
        DeemDown: {
            value: 3,
            text: 'DeemDown'
        }
    },
    eLocationStatus: {
        WaitingTarget: {
            value: 1,
            text: 'status.waitingTarget',
            color: '#FFBB28'
        },
        PendentSend: {
            value: 2,
            text: 'status.pendentSend',
            color: '#FF8042'
        },
        Finished: {
            value: 3,
            text: 'status.finished',
            color: '#66CC33'
        },
        Canceled: {
            value: 4,
            text: 'status.canceled',
            color: ''
        },
        NotPermitted: {
            value: 5,
            text: 'status.notPermitted',
            color: '#00C49F'
        }
    },
    eModules: {
        PhysicalConfirmation: {
            value: 1,
            text: 'Conferência Física',
        },
        LoadUnload: {
            value: 2,
            text: 'Carga Descarga',
        },
        Picking: {
            value: 3,
            text: 'Picking',
        },
        Location: {
            value: 4,
            text: 'Troca de Locação',
        },
        Inventory: {
            value: 5,
            text: 'Inventário',
        },
        DigitalTracking: {
            value: 6,
            text: 'Digital Tracking',
        },
        User: {
            value: 7,
            text: 'Usuário',
        },
        LinePicking: {
            value: 8,
            text: 'Atendimento de linha'
        },
        Volume: {
            value: 9,
            text: 'Volume'
        },
        AtendimentoDeLinha: {
            value: 10,
            text: 'Atendimento de Linha'
        },
        Delivery: {
            value: 11,
            text: 'Delivery'
        },
        WarehouseManagement: {
            value: 12,
            text: 'WarehouseManagement'
        },
        ContainerYard: {
            value: 13,
            text: 'Patio de Container'
        }
    },
    eAreaType: {
        Shed: {
            value: 1,
            text: 'data.shed'
        },
        Yard: {
            value: 2,
            text: 'data.yard'
        },
        Gate: {
            value: 3,
            text: 'data.gate'
        }
    },
    eUnitType: {
        Dock: {
            value: 1,
            text: 'data.dock'
        },
        Queue: {
            value: 2,
            text: 'data.queue'
        },
        Addressing: {
            value: 3,
            text: 'data.addressing'
        },
        EntranceArea: {
            value: 4,
            text: 'data.entranceArea'
        }
    },
    eWareHouseType: {
        SmallParts: {
            value: 1,
            text: 'data.smallparts'
        },
        Kanban: {
            value: 2,
            text: 'data.kanban'
        }
    },
    eModality: {
        LinePicking: {
            value: 4,
            text: 'data.linePicking'
        },
        Load: {
            value: 1,
            text: 'data.load'
        },
        Unload: {
            value: 2,
            text: 'data.unload'
        },
        LoadAndUnload: {
            value: 3,
            text: 'data.loadAndUnload'
        }
    },
    eVolumeType: {
        Box: {
            value: 1,
            text: 'volumeType.box'
        },
        Container: {
            value: 2,
            text: 'volumeType.container'
        }
    },
    eTypeAlert: {
        Blue:
        {
            typeAlertId: 1,
            value: 1,
            color: '#0000FF',
            text: 'Azul',
            quantity: undefined,
            time: undefined
        },
        Yellow: {
            typeAlertId: 2,
            value: 2,
            color: '#FFD700',
            text: 'Amarelo',
            quantity: undefined,
            time: undefined
        },
        Red: {
            typeAlertId: 3,
            value: 3,
            color: '#FF0000',
            text: 'Vermelho',
            quantity: undefined,
            time: undefined
        }
    },
    eUnitOrdering: {
        Street: {
            value: 1,
            text: 'data.street'
        },
        Standard: {
            value: 2,
            text: 'data.standard'
        },
        QueueUpColumnUp: {
            value: 3,
            text: 'data.queueUpColumnUp'
        },
        QueueUpColumnDown: {
            value: 4,
            text: 'data.queueUpColumnDown'
        },
        QueueDownColumnUp: {
            value: 5,
            text: 'data.queueDownColumnUp'
        },
        QueueDownColumnDown: {
            value: 6,
            text: 'data.queueDownColumnDown'
        }
    },
    eMultiEmpresa: {
        Yes: {
            value: true,
            text: 'yes'
        },
        No: {
            value: false,
            text: 'no'
        }
    },
    ePrintTypes: {
        Click: {
            value: "C",
            text: 'printTypes.click'
        },
        Logistics: {
            value: "L",
            text: 'printTypes.logistics'
        },
        NotPrint: {
            value: "N",
            text: 'printTypes.notprint'
        }
    },
    eTransmissionType: {
        Manual: {
            value: "1",
            text: 'transmissionType.manual'
        },
        Massive: {
            value: "2",
            text: 'transmissionType.massive'
        },
        Finalization: {
            value: "3",
            text: 'transmissionType.finalization'
        },
        ChangeLocation: {
            value: "4",
            text: 'transmissionType.changeLocation'
        },
        Grouped: {
            value: "5",
            text: 'transmissionType.grouped'
        },
        Container: {
            value: "6",
            text: 'transmissionType.container'
        },
        Automatic: {
            value: "7",
            text: 'transmissionType.automatic'
        },
        Reprocess: {
            value: "8",
            text: 'transmissionType.reprocess'
        },
        WithoutMvm: {
            value: "9",
            text: 'transmissionType.withoutmvm'
        },
        AutomaticLow: {
            value: "10",
            text: 'transmissionType.automaticlow'
        }
    },
    eLogInventoryOperation: {
        SendReading: {
            value: "1",
            text: 'logOperation.sendReading'
        },
        SendReadingCloseLot: {
            value: "2",
            text: 'logOperation.sendReadingCloseLot'
        },
        CloseLot: {
            value: "3",
            text: 'logOperation.closeLot'
        }
    },
    eStockOperation: {
        Partnumber: {
            value: "3",
            text: 'stock:write-off-by-partnumber'
        },
        BarCode: {
            value: "4",
            text: 'stock:write-off-by-barcode'
        },
        Area: {
            value: "5",
            text: 'stock:write-off-by-location'
        },
        Quality: {
            value: "6",
            text: 'stock:write-off-by-quality'
        },
        Task: {
            value: "7",
            text: 'stock:write-off-by-task'
        },
        Pab: {
            value: "9",
            text: 'pab'
        }
    },
    eDiffusionLogStatus: {
        Waiting: {
            value: "1",
            text: 'stock:diffusion-status-waiting'
        },
        Executed: {
            value: "2",
            text: 'stock:diffusion-status-executed'
        },
        Error: {
            value: "3",
            text: 'stock:diffusion-status-error'
        },
        NotDifussion: {
            value: "4",
            text: 'stock:diffusion-status-notDifussion'
        },
    },
    eCimStatus: {
        Available: {
            value: 'AVAILABLE',
            text: 'available'
        },
        Wipexp: {
            value: 'WIPEXP',
            text: 'WIPEXP'
        },
    },
    eFormType: {
        Deem: {
            value: '1',
            text: 'Deem'
        },
        Sqp: {
            value: '2',
            text: 'Sqp'
        },
    },
    eEnableMdrAlternative: {
        Yes: {
            value: true,
            text: 'yes'
        },
        No: {
            value: false,
            text: 'no'
        }
    },
    ePrinterManufacturerPortable: {
        Zebra: {
            value: 1,
            text: 'Zebra'
        },
        Honeywell: {
            value: 2,
            text: 'Honeywell'
        }
    },
    eCimFileStatus: {
        Success: {
            value: true,
            text: 'general:success'
        },
        Error: {
            value: false,
            text: 'general:erro'
        }
    },
    eRouteType: {
        NotSelected: {
            value: 0,
            text: 'NotSelected'
        },
        LinePicking: {
            value: 1,
            text: 'LinePicking'
        },
        Lowering: {
            value: 2,
            text: 'Lowering'
        }
    },
    eTypeOrdenation: {
        All: {
            value: 0,
            text: 'all'
        },
        Pair: {
            value: 1,
            text: 'pair'
        },
        Odd: {
            value: 2,
            text: 'odd'
        }
    },
    eTypeScheduleCalculation: {
        Coverage: {
            value: 1,
            text: 'Cobertura'
        },
        Spawn: {
            value: 2,
            text: 'Desova'
        }
    },
    eMappingRegistrationType: {
        Class: {
            value: 1,
            text: 'Class'
        },
        Line: {
            value: 2,
            text: 'Line'
        },
        Parts: {
            value: 3,
            text: 'Parts'
        },
        Gravitational: {
            value: 4,
            text: 'Gravitational'
        }
    },
    eLineBorder: {
        Empty: {
            value: 0,
            text: 'Em Branco'
        },
        Automatic: {
            value: 1,
            text: 'Automatico'
        },
        Manual: {
            value: 2,
            text: 'Manual'
        }
    },
    eLineBorderType: {
        AD: {
            value: 1,
            text: 'A&D'
        },
        A: {
            value: 2,
            text: 'A'
        },
        D: {
            value: 3,
            text: 'D'
        }
    },
    eContainerStatus: {
        Transport: {
            value: 1,
            text: 'Transporte'
        },
        InPort: {
            value: 2,
            text: 'No Porto'
        },
        Released: {
            value: 3,
            text: 'Liberado na Planta'
        },
        InPlant: {
            value: 4,
            text: 'Na Planta'
        },
        InYard: {
            value: 5,
            text: 'No Pátio'
        },
        DockTransit: {
            value: 6,
            text: 'Transito Doca'
        },
        Unloaded: {
            value: 7,
            text: 'Descarregado'
        },
        ReturnToYard: {
            value: 8,
            text: 'Retorno Pátio'
        },
        ExitYard: {
            value: 9,
            text: 'Saída Pátio'
        },
        Exit: {
            value: 10,
            text: 'Saida'
        },
        ReturnToPort: {
            value: 11,
            text: 'Retorno Porto'
        },
        NotFound: {
            value: 12,
            text: 'Sem Status'
        }

    },
    eFreeTimeDelayedStatus: {
        OnTime: {
            value: false,
            text: 'Em Dia'
        },
        Delayed: {
            value: true,
            text: 'Atrasado'
        }
    },
    eFreeTimeStatus: {
        OnTime: {
            value: 1,
            text: 'Em Dia'
        },
        Delayed: {
            value: 2,
            text: 'Atrasado'
        },
        NoRule: {
            value: 3,
            text: 'Sem regra cadastrada'
        }
    },
    eContainerState: {
        IsEmpty: {
            value: true,
            text: 'Vazio'
        },
        IsFull: {
            value: false,
            text: 'Cheio'
        }
    },
};

export const MODULES_CONFIGS = {
    PhysicalConfirmation: [
        // { label: 'physicalConfirmation.instantReceiptConfirmation', key: 'instantReceiptConfirmation', type: 'checkbox', moduleId: ENUMS.eModules.PhysicalConfirmation.value, admin: true },
        // { label: 'physicalConfirmation.printLabelPhysicalConfirmation', key: 'printLabelPhysicalConfirmation', type: 'checkbox', moduleId: ENUMS.eModules.PhysicalConfirmation.value, admin: true },
        // { label: 'physicalConfirmation.MdrRequiredReceipt', key: 'MdrRequiredReceipt', type: 'checkbox', moduleId: ENUMS.eModules.PhysicalConfirmation.value, admin: true },
        // { label: 'physicalConfirmation.showMdrReceipt', key: 'showMdrReceipt', type: 'checkbox', moduleId: ENUMS.eModules.PhysicalConfirmation.value, admin: true },
        { label: 'physicalConfirmation.enableModalConfirmDeem', key: 'enableModalConfirmDeem', type: 'checkbox', moduleId: ENUMS.eModules.PhysicalConfirmation.value },
        { label: 'physicalConfirmation.enableModalConfirmSqp', key: 'enableModalConfirmSqp', type: 'checkbox', moduleId: ENUMS.eModules.PhysicalConfirmation.value },
        { label: 'physicalConfirmation.generateLabelLaser', key: 'generateLabelLaser', type: 'checkbox', moduleId: ENUMS.eModules.PhysicalConfirmation.value },
        { label: 'physicalConfirmation.dockRequiredPhysicalConfirmation', key: 'dockRequiredPhysicalConfirmation', type: 'checkbox', moduleId: ENUMS.eModules.PhysicalConfirmation.value, admin: true },
        { label: 'physicalConfirmation.shedRequiredPhysicalConfirmation', key: 'shedRequiredPhysicalConfirmation', type: 'checkbox', moduleId: ENUMS.eModules.PhysicalConfirmation.value, admin: true },
        { label: 'physicalConfirmation.masterCimPallets', key: 'masterCimPallets', type: 'checkbox', moduleId: ENUMS.eModules.PhysicalConfirmation.value, admin: true },
        { label: 'physicalConfirmation.automaticPrintOption', key: 'automaticPrintOption', type: 'checkbox', moduleId: ENUMS.eModules.PhysicalConfirmation.value, admin: false },
        { label: 'physicalConfirmation.generateLargerDeem', key: 'generateLargerDeem', type: 'checkbox', moduleId: ENUMS.eModules.PhysicalConfirmation.value, admin: false },
        { label: 'physicalConfirmation.generateSmallerDeem', key: 'generateSmallerDeem', type: 'checkbox', moduleId: ENUMS.eModules.PhysicalConfirmation.value, admin: false },
        { label: 'physicalConfirmation.controlDeparaUSer', key: 'controlDeparaUSer', type: 'checkbox', moduleId: ENUMS.eModules.PhysicalConfirmation.value, admin: false },
        { label: 'physicalConfirmation.mdrBaiCode', key: 'mdrBaiCode', type: 'text', moduleId: ENUMS.eModules.PhysicalConfirmation.value, admin: false },
        { label: 'physicalConfirmation.automaticReceiveAlmox', key: 'automaticReceiveAlmox', type: 'text', moduleId: ENUMS.eModules.PhysicalConfirmation.value },
        { label: 'physicalConfirmation.enableAlternativeMdr', key: 'enableAlternativeMdr', type: 'checkbox', moduleId: ENUMS.eModules.PhysicalConfirmation.value, admin: true },
        {
            label: 'physicalConfirmation.printOption', key: 'printOption', type: 'drop', moduleId: ENUMS.eModules.PhysicalConfirmation.value, admin: false, values: [
                {
                    id: "qme", text: "QME"
                },
                {
                    id: "saldo", text: "Saldo Total"
                }
            ]
        },
        { label: 'physicalConfirmation.alternativeMDRAreas', key: 'alternativeMDRAreas', type: 'text', moduleId: ENUMS.eModules.PhysicalConfirmation.value, admin: false },
        { label: 'physicalConfirmation.usersDepara', key: 'usersDepara', type: 'text', moduleId: ENUMS.eModules.PhysicalConfirmation.value, admin: false, dependency: 'controlDeparaUSer' }
    ],
    Location: [
        { label: 'location.readReceiptProcessCode', key: 'readReceiptProcessCode', type: 'text', moduleId: ENUMS.eModules.Location.value },
        { label: 'location.updateReceiptProcessCode', key: 'updateReceiptProcessCode', type: 'text', moduleId: ENUMS.eModules.Location.value },
    ],
    Inventory: [
        { label: 'inventory.levelsDrone', key: 'levelsDrone', type: 'text', moduleId: ENUMS.eModules.Inventory.value }
    ],
    User: [
        { label: "user.enableKeyboard", key: 'enableKeyboard', type: 'checkbox', moduleId: ENUMS.eModules.User.value },
        { label: "user.shed", key: 'shed', type: 'drop', moduleId: ENUMS.eModules.User.value },
        { label: "user.dock", key: 'dock', type: 'drop', moduleId: ENUMS.eModules.User.value },
        { label: "user.resource", key: 'resource', type: 'drop', moduleId: ENUMS.eModules.User.value },
        { label: "user.resourceLaser", key: 'resourceLaser', type: 'drop', moduleId: ENUMS.eModules.User.value },
        { label: "user.equipment", key: 'equipment', type: 'drop', moduleId: ENUMS.eModules.User.value },
        { label: "user.print", key: 'print', type: 'drop', moduleId: ENUMS.eModules.User.value },
        { label: "user.unit", key: 'unitId', type: 'drop', moduleId: ENUMS.eModules.User.value }
    ],
    WarehouseManagement: [
        { label: 'warehouseManagement.areasReportQueue', key: 'areasReportQueue', type: 'text', moduleId: ENUMS.eModules.WarehouseManagement.value },
        { label: 'warehouseManagement.difusionAutomatic', key: 'difusionAutomatic', type: 'checkbox', moduleId: ENUMS.eModules.WarehouseManagement.value },
    ],
    LinePicking: [
        { label: 'line-picking.quantityAlignment', key: 'quantityAlignment', type: 'checkbox', moduleId: ENUMS.eModules.LinePicking.value },
    ],
    Demurrage: [
        { label: 'container.demurageAlertDays', key: 'demurrageAlertDays', type: 'number', moduleId: ENUMS.eModules.ContainerYard.value },
    ]
};

export const SIGNALR_GROUPS = {
    Expedition: {
        Default: 'EXPEDITION_GROUP',
        Picking: 'EXPEDITION_PICKING_GROUP',
        LinePicking: 'EXPEDITION_LINE_PICKING_GROUP',
    },
    Inventory: {
        Default: 'INVENTORY_GROUP'
    },
    PhysicalConfirmation: {
        Default: 'PHYSICAL_CONFIRMATION_GROUP'
    },
    ShipmentTracking: {
        Default: 'SHIPMENT_TRACKING_GROUP'
    }
};

export const eKeyboardBehaviorAndroid = {
    Padding: 'padding',
    Height: 'height',
    Position: 'position'
};

export const VISIONS = {
    Fiasa: '1-1',
    PoweTrain: '10-10',
    Mecanica: '12-1',
    Jeep: '191-1',
    Faasa: '162-3',
    FaasaCKD: '162-18',
    Palomar: '629-0',
    PortoReal: '630-0'
}

export const SITES = {
    Faasa: 'FAASA',
    FaasaCKD: 'FAASA_CKD'
}

export const PLANTS = {
    PoweTrain: "00196",
    Mecanica: "00194",
    Faasa: "00162",
    FaasaCKD: "00162",
    Fiasa: "00161",
    Jeep: "00191",
    Palmoar: '00629',
    PortoReal: '00630'
}


export const LOAD_UNLOAD_JUSTIFICATION_LIST = [
    { code: 1, label: 'Absenteísmo' },
    { code: 2, label: 'Falta de espaço físico almoxarifado' },
    { code: 3, label: 'Falta de equipamento (Empilhadeira)' },
    { code: 4, label: 'Notas fiscais em Contingência/SEFAZ' },
    { code: 5, label: 'Acidente/Quebras veículo' },
    { code: 6, label: 'Queda de energia' },
    { code: 7, label: 'Indisponibilidade de embalagem' },
    { code: 8, label: 'Conferência vigilância' },
    { code: 9, label: 'Troca de turno / Refeição' },
    { code: 10, label: 'DEEM/Qualidade/SQP/BO' },
    { code: 11, label: 'Motorista não atende chamado para descarga/carga' },
    { code: 12, label: 'Condições Climáticas' },
    { code: 13, label: 'Prioridade de descarga em veículos com peças crítica' },
    { code: 14, label: 'Motorista Recusa o Carregamento​' },
    { code: 15, label: 'Material sem Digitação​' },
    { code: 16, label: 'Embalagem sem Cadastro Código e/ou Custo​​' },
    { code: 17, label: 'Aguardando Nota Fiscal​​' },
    { code: 18, label: 'Congestionamento Logístico - Pátio' },
    { code: 19, label: 'Sistemas Stellantis' },
];